<div class="dynamic-width-back"
     [ngClass]="{selectedBackground:isSelected ,unselectedBackground:!isSelected}"
     [ngStyle]="{'width.px': indicatorWidth ==0 ? '1' : indicatorWidth }"></div>
